import { createSlice } from "@reduxjs/toolkit";

const nuditySlice = createSlice({
  name: "nuditySlice",
  initialState: {
    screenshotData: null,
  },
  reducers: {
    setScreenshotData: (state, action) => {
      state.screenshotData = action?.payload;
    },
  },
});

// this is for dispatch
export const { screenshotData } = nuditySlice.actions;

// this is for configureStore
export default nuditySlice.reducer;
